module.exports = __webpack_public_path__ + "static/media/img_football_formation.fa29f9b1.png";